module.exports = __webpack_public_path__ + "img/bg-earning_strategy2.b94e729a.png";